import { useState } from 'react';
import { useStock } from '@services/stock';
import placeholder from '../../../../assets/images/insights/product-thumbnail-placeholder.svg';
import styles from './SwisScreenshot.module.scss';

export function ProductCard({ barcode, shopId }) {
	const [imageError, setImageError] = useState(false);

	const { data: stockItem, isLoading } = useStock(barcode.toUpperCase(), shopId);

	if (isLoading) {
		return (
			<div className={styles.swisMockUpProductCard}>
				<img height="30px" className={styles.swisMockUpProductImage} src={placeholder} alt="Placeholder product" />
				<div className={styles.swisMockUpProductTextContainer}>
					<p>Your most popular product</p>
					<p>
						<span className={styles.swisMockUpProductInStock}></span>In stock
					</p>
				</div>
			</div>
		);
	}
	const name = stockItem?.title || 'Your most popular product';
	let image = stockItem?.images || placeholder;

	if (imageError) {
		image = placeholder;
	}
	return (
		<div className={styles.swisMockUpProductCard}>
			<img height="30px" className={styles.swisMockUpProductImage} src={image} alt={`${name}`} onError={() => setImageError(true)} />
			<div className={styles.swisMockUpProductTextContainer}>
				<p>{name.slice(0, 20) + '...'}</p>
				<p>
					<span className={styles.swisMockUpProductInStock}></span>In stock
				</p>
			</div>
		</div>
	);
}

export function DefaultProductCard() {
	const name = 'Your most popular product';
	const image = placeholder;

	return (
		<div className={styles.swisMockUpProductCard}>
			<img height="30px" className={styles.swisMockUpProductImage} src={image} alt={`Product image for ${name}`} />
			<div className={styles.swisMockUpProductTextContainer}>
				<p>{name.slice(0, 25) + '...'}</p>
				<p>
					<span className={styles.swisMockUpProductInStock}></span>In stock
				</p>
			</div>
		</div>
	);
}
